import { Helmet } from "react-helmet-async";

const SITE = "https://reverenceautos.ca";
const AREAS = ["Orleans", "Kanata", "Barrhaven", "Nepean", "Stittsville", "Downtown Ottawa", "Gatineau"];

export function LocalBusinessJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "AutoWash",
    name: "Reverence Autos",
    description: "Ottawa's largest mobile car detailing crew. Interior, full detail, express and ceramic coating — we come to you.",
    url: SITE,
    telephone: "+1-613-854-6086",
    priceRange: "$$",
    areaServed: AREAS.map((a) => ({ "@type": "City", name: a })),
    address: { "@type": "PostalAddress", addressLocality: "Ottawa", addressRegion: "ON", addressCountry: "CA" },
    aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "512" },
    makesOffer: [
      { "@type": "Offer", name: "Express 90-Min Refresh", price: "75", priceCurrency: "CAD" },
      { "@type": "Offer", name: "Full Detail", price: "169", priceCurrency: "CAD" },
      { "@type": "Offer", name: "Ceramic Coating", price: "249", priceCurrency: "CAD" },
    ],
  };
  return <Helmet><script type="application/ld+json" data-testid="jsonld-localbusiness">{JSON.stringify(data)}</script></Helmet>;
}

export function FaqJsonLd({ faq }) {
  if (!faq?.length) return null;
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
  return <Helmet><script type="application/ld+json" data-testid="jsonld-faq">{JSON.stringify(data)}</script></Helmet>;
}

export function BreadcrumbJsonLd({ items }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE}${it.path}` })),
  };
  return <Helmet><script type="application/ld+json" data-testid="jsonld-breadcrumb">{JSON.stringify(data)}</script></Helmet>;
}

export default function Seo({ title, description, path = "", image, jsonLd }) {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json" data-testid="jsonld-page">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
